import { NavLink } from "react-router-dom";
import { cn } from "@/utils/cn";

export type UnionRosterTabs = "MY" | "ALL";
export function RosterTabs({
  myHref = "/roster_view/my",
  allHref = "/roster_view/all",
}: {
  readonly myHref?: string;
  readonly allHref?: string;
}) {
  return (
    <nav aria-label="근무표 탭" className="flex shrink-0 items-center gap-5">
      {[
        [myHref, "내 근무표"],
        [allHref, "전체 근무표"],
      ].map(([href, label]) => (
        <NavLink
          key={label}
          to={href}
          className={({ isActive }) =>
            cn(
              "whitespace-nowrap border-b-2 px-1 py-2 text-lg font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              isActive
                ? "border-sig text-sig"
                : "border-transparent text-muted-foreground hover:text-foreground"
            )
          }
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
